import { BOT_NAMES } from "constants/botNames";

function botCodeToName(code) {
  return BOT_NAMES[code];
}

export { botCodeToName };
